import { PaymentMethodTypesEnum } from '@sola/schema/dotcom/supporters/paymentMethods.ts';

const getIsPaymentMethod =
  <T extends PaymentMethodTypesEnum>(enumType: T) =>
  (paymentMethodType: PaymentMethodTypesEnum): paymentMethodType is T =>
    paymentMethodType === enumType;

export const isPaymentMethodAch = getIsPaymentMethod(
  PaymentMethodTypesEnum.Ach,
);
export const isPaymentMethodCard = getIsPaymentMethod(
  PaymentMethodTypesEnum.Card,
);
